import moment from "moment";
import React, { CSSProperties, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { adToBe } from "react-lib/utils/dateUtils";
import { Button, Divider, Grid, Icon, Image } from "semantic-ui-react";

type ChatPostponeProps = {
  contentType: any;
  contentPayload: any;
  channelId: any;
  chatName: any;
  division: any;
  onClickMessage: any;
};

const ChatPostpone = (props: ChatPostponeProps) => {
  const [dataMessage, setDataMessage] = useState<any>({});
  const intl = useIntl();

  useEffect(() => {
    if (props.contentPayload != null) {
      let routePath = "/ConfirmTelephar/";
      const providerId = props.contentPayload?.provider_id || "";
      const startDate = adToBe(
        moment(props.contentPayload?.start_datetime).format("DD/MM/YYYY")
      );
      const date = props.contentPayload?.start_datetime
        ? moment(startDate, "DD/MM/YYYY").format("DD MMMM YYYY")
        : intl.formatMessage({ id: "bplusClinicKey1459" });

      const appointmentDate = props.contentPayload?.appointment_datetime;

      const startDateTime =
        appointmentDate || props.contentPayload?.start_datetime
          ? moment(
              appointmentDate || props.contentPayload?.start_datetime
            ).format("HH:mm")
          : intl.formatMessage({ id: "bplusClinicKey1460" });

      const endDateTime =
        appointmentDate || props.contentPayload?.end_datetime
          ? moment(
              props.contentPayload?.slot_length
                ? appointmentDate
                : props.contentPayload?.end_datetime
            )
              .clone()
              .add(props.contentPayload?.slot_length || "0", "minutes")
              .format("HH:mm")
          : intl.formatMessage({ id: "bplusClinicKey1460" });
      const appointmentId = props.contentPayload?.patient_appointment_id || "";

      setDataMessage({
        providerId: providerId,
        date: date,
        channelId: props.channelId,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        appointmentId: appointmentId,
        chatName: props.chatName,
        division: props.contentPayload?.division || "",
      });
    }
  }, []);

  const handleClickMessage = () => {
    const unknownTime =
      !props.contentPayload?.end_datetime &&
      !props.contentPayload?.start_datetime;

    const state = {
      date: dataMessage.date,
      time: unknownTime
        ? intl.formatMessage({id: "bplusClinicKey1460"})
        : `${dataMessage.startDateTime}-${dataMessage.endDateTime}`,
      channelId: dataMessage.channelId,
      chatName: dataMessage.chatName,
      division: dataMessage.division,
      provider: dataMessage.providerId,
      appointmentId: dataMessage.appointmentId,
    };
    props.onClickMessage(state);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ minWidth: "max-content" }}>
        {`นัดหมายเพื่อให้คำปรึกษายาของท่าน`}
      </div>
      {/* <div
        style={{
          ...(!(props.contentPayload.status === 4) && { display: "none" }),
          color: "#F03A3A",
        }}
      >
        {`ถูกเลื่อนเป็น`}
      </div> */}
      <div
      // style={{
      //   ...((props.contentPayload.status === 4)&& { color: "#F03A3A" }),
      // }}
      >
        {`วันที่: ${dataMessage.date}`}
      </div>
      <div
      // style={{
      //   ...((props.contentPayload.status === 4)&& { color: "#F03A3A" }),
      // }}
      >
        {`เวลา: ${
          !props.contentPayload?.end_datetime &&
          !props.contentPayload?.start_datetime
            ? intl.formatMessage({id: "bplusClinicKey1460"})
            : `${dataMessage.startDateTime}-${dataMessage.endDateTime}`
        }`}
      </div>
      <div style={{ marginTop: "25px", whiteSpace: "pre-line" }}>
        {`หากท่านไม่สะดวกในเวลาดังกล่าว\nกรุณาเลือก “เลื่อนนัดหมาย”\nเพื่อเปลี่ยนแปลงเวลานัดหมาย`}
      </div>
      <div
        style={{
          margin: "10px 0",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          style={{
            background: "#0147A3",
            borderRadius: "10",
            color: "white",
          }}
          onClick={() => handleClickMessage()}
        >
          เลื่อนนัดหมาย
        </Button>
      </div>
    </div>
  );
};

export default React.memo(ChatPostpone);
